import React, { useEffect, useState } from "react";
import { useParams, useLocation } from "react-router-dom";

export default function RequestDetails() {
  const { id } = useParams();
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const type = params.get("type");
  const [request, setRequest] = useState(null);
  const [comments, setComments] = useState([]);
  const [comment, setComment] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchRequest = async () => {
      setLoading(true);
      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/${type}/requests/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        });
        const data = await res.json();
        if (res.ok) {
          setRequest(data.request);
          setComments(data.comments || []);
        } else {
          setError(data.message || "Failed to load request.");
        }
      } catch {
        setError("Network error.");
      }
      setLoading(false);
    };
    fetchRequest();
  }, [id, token]);

  const handleCommentSubmit = async (e) => {
    e.preventDefault();
    if (!comment.trim()) return;
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/${type}/requests/${id}/comments`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify({ comment }),
      });
      const data = await res.json();
      if (res.ok) {
        setComments([...comments, data.comment]);
        setComment("");
      } else {
        alert(data.message || "Failed to add comment.");
      }
    } catch {
      alert("Network error.");
    }
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div className="text-red-600">{error}</div>;
  if (!request) return null;

  return (
    <div className="max-w-2xl mx-auto bg-white rounded shadow p-6 mt-8">
      <h2 className="text-2xl font-bold mb-4">Request Details</h2>
      <div><strong>Title:</strong> {request.title}</div>
      <div><strong>Status:</strong> {request.status}</div>
      <div><strong>Lawyer:</strong> {request.lawyer_name || "N/A"}</div>
      <div><strong>Client:</strong> {request.client_name || "N/A"}</div>
      <div><strong>Message:</strong> {request.message}</div>
      <div><strong>Created:</strong> {new Date(request.created_at).toLocaleString()}</div>
      <div className="mt-4">
        <strong>Documents:</strong>
        <ul>
          {Array.isArray(request.documents) && request.documents.length > 0 ? (
            request.documents.map((doc, idx) => (
              <li key={idx}>
                <a
                  href={`${process.env.REACT_APP_API_URL.replace(/\/$/, "")}/storage/${doc}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-blue-700 underline"
                  download
                >
                  Document {idx + 1}
                </a>
              </li>
            ))
          ) : (
            <li>No documents uploaded.</li>
          )}
        </ul>
      </div>
      <div className="mt-6">
        <h3 className="font-semibold mb-2">Comments</h3>
        <div className="max-h-48 overflow-y-auto border rounded p-2 mb-2 bg-gray-50">
          {comments.length > 0 ? (
            comments.map((c, idx) => (
              <div key={idx} className="mb-2">
                <span className="font-semibold">{c.user_name}:</span> {c.comment}
                <div className="text-xs text-gray-500">{new Date(c.created_at).toLocaleString()}</div>
              </div>
            ))
          ) : (
            <div>No comments yet.</div>
          )}
        </div>
        <form onSubmit={handleCommentSubmit} className="flex gap-2">
          <input
            type="text"
            value={comment}
            onChange={e => setComment(e.target.value)}
            className="border rounded px-2 py-1 flex-1"
            placeholder="Type your comment..."
          />
          <button
            type="submit"
            className="bg-blue-700 text-white px-4 py-1 rounded hover:bg-blue-800"
          >
            Send
          </button>
        </form>
      </div>
    </div>
  );
}
